import { Routes } from '@angular/router';
import { permissionGuard } from './shared/guards/permission.guard';
import { redirectIfLoggedGuard } from './shared/guards/redirectIfLogged.guard';

export const routes: Routes = [
  {
    path: 'login',
    loadComponent: () =>
      import('./core/components/login/login.component').then(c => c.LoginComponent),
    canActivate: [redirectIfLoggedGuard],
  },
  {
    path: '',
    loadComponent: () => import('./shell/shell.component').then(c => c.ShellComponent),
    canMatch: [permissionGuard],
    data: { permission: 'role.operator' },
    children: [
      {
        path: 'amministrazione',
        loadChildren: () =>
          import('./features/operators/operators.routes').then(m => m.OPERATORS_ROUTES),
        canMatch: [permissionGuard],
        data: { permission: 'operator.list', title: 'Amministrazione' },
      },
      {
        path: 'assistiti',
        loadChildren: () =>
          import('./features/patients/patients.routes').then(m => m.PATIENTS_ROUTES),
        canMatch: [permissionGuard],
        data: { permission: 'personaldata.user.list', title: 'Assistiti' },
      },
      {
        path: 'supporto',
        loadChildren: () => import('./features/support/support.routes').then(m => m.SUPPORT_ROUTES),
        canMatch: [permissionGuard],
        data: { isPublic: true, title: 'Supporto' },
      },
      {
        path: '',
        pathMatch: 'full',
        redirectTo: 'amministrazione',
      },
    ],
  },
  {
    path: '',
    loadComponent: () => import('./shell/shell.component').then(c => c.ShellComponent),
    canMatch: [permissionGuard],
    data: { permission: 'role.sys-admin' },
    children: [
      {
        path: 'amministrazione',
        loadChildren: () =>
          import('./features/operators/operators.routes').then(m => m.OPERATORS_ROUTES),
        canMatch: [permissionGuard],
        data: { permission: 'personaldata.user.list', title: 'Amministrazione' },
      },
      {
        path: 'assistiti',
        loadChildren: () =>
          import('./features/patients/patients.routes').then(m => m.PATIENTS_ROUTES),
        canMatch: [permissionGuard],
        data: { permission: 'personaldata.user.list', title: 'Assistiti' },
      },
      {
        path: 'supporto',
        loadChildren: () => import('./features/support/support.routes').then(m => m.SUPPORT_ROUTES),
        canMatch: [permissionGuard],
        data: { isPublic: true, title: 'Supporto' },
      },
      {
        path: '',
        pathMatch: 'full',
        redirectTo: 'amministrazione',
      },
    ],
  },
  {
    path: '',
    loadComponent: () => import('./shell/shell.component').then(c => c.ShellComponent),
    canMatch: [permissionGuard],
    data: { permission: 'role.patient' },
    children: [
      {
        path: 'profilo',
        loadComponent: () =>
          import('./features/profile/pages/profile/profile.component').then(
            m => m.ProfileComponent
          ),
        data: { title: 'Profilo' },
      },
      {
        path: 'diario/:id',
        loadChildren: () =>
          import('./features/projects-diary/project-diary.routes').then(
            m => m.PROJECT_DIARY_ROUTES
          ),
        data: { title: 'Diario' },
      },
      {
        path: 'supporto',
        loadChildren: () => import('./features/support/support.routes').then(m => m.SUPPORT_ROUTES),
        canMatch: [permissionGuard],
        data: { isPublic: true, title: 'Supporto' },
      },
      {
        path: '',
        pathMatch: 'full',
        redirectTo: 'profilo',
      },
    ],
  },
  {
    path: '',
    pathMatch: 'full',
    redirectTo: 'login',
  },
];
